<template>
  <div>
    <v-icon v-if="estatus == 'E'" color="red" @click="mostrarDialogo = true">
      mdi-close-outline
    </v-icon>

    <v-icon v-else color="green" @click="mostrarDialogo = true">
      mdi-check-outline    
    </v-icon>

    <v-dialog v-model="mostrarDialogo" max-width="450px">
      <v-card>
        <v-card-title v-if="estatus == 'A'" class="d-flex justify-center">
          <h3 class="mx-3">¿Confirmar que el producto ha sido entregado?</h3>
        </v-card-title>

        <v-card-title v-else class="d-flex justify-center">
          <h3 class="mx-3">¿Desea regresar al ESTATUS ACTIVO el artículo seleccionado?</h3>
        </v-card-title>

        <v-spacer />

        <v-card-text v-if="estatus == 'A'" class="d-flex justify-center">
          <span class="px-2 font-weight-bold text-subtitle-1 text--primary">
            ¿Desea confirmar como 
            <span :class="[clase]">ENTREGADO</span>
            el artículo 
            <span class="mx-1" :class="[clase]">
              {{ nombre }}</span
            >?</span
          >
        </v-card-text>

        <v-card-text v-else class="d-flex justify-center">
          <span class="px-2 font-weight-bold text-subtitle-1 text--primary">
            ¿Regresar al estatus 
            <span :class="[clase]">ACTIVO</span>
            el artículo 
            <span class="mx-1" :class="[clase]">
              {{ nombre }}</span
            >?</span
          >
        </v-card-text>

        <v-spacer></v-spacer>

        <div class="d-flex justify-center">
          <v-card-actions class="mx-2 my-1">
            <v-btn text class="primary" @click="mostrarDialogo = false">
              CANCELAR
            </v-btn>
            <v-btn v-if="estatus == 'A'" text dark class="grey darken-1" @click="cambiarEstatus('E')">
              ENTREGADO
            </v-btn>
            <v-btn v-else text dark class="grey darken-1" @click="cambiarEstatus('A')">
              RE-ACTIVAR
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  props: ["infoArticulo"],
  data() {
    return {
      mostrarDialogo: false,

      nombre: this.infoArticulo.NOMBRE,
      estatus: this.infoArticulo.ESTATUS,

      mensajeAccion: "",
      clase: "",
    };
  },

  computed: {
    ...mapGetters(["getURLAPI", "getUsuario", "getFechaActual"]),
  },
  methods: {
    cambiarEstatus(estatusActual) {
      let datosForm = new FormData();
      let estatus = estatusActual;
      console.log("Orden ID:"+this.infoArticulo.ORDEN_COMPRA_ID);
      console.log("estatus enviado "+estatus);
      datosForm.append("ARTICULO_ID", this.infoArticulo.ARTICULO_ID);
      datosForm.append("ESTATUS",estatus);

      axios
        .post(
          `${this.getURLAPI}/Ordenes/articuloEntregado/${this.infoArticulo.ORDEN_COMPRA_ID}`,
          datosForm
        )
        .then((res) => {
          this.$root.vtoast.show({
            message: res.data.MSG || "Error",
            color:
              res.data.STATUS == "OK" ? "success darken-1" : "red darken-1",
            timer: 10000,
            icon:
              res.data.STATUS == "OK"
                ? "mdi-check"
                : "mdi-alert-circle-outline",
          });
          this.$emit("actualizarTabla");
          this.mostrarDialogo = false;
        });
    },
  },

  created() {
    // COLOR DE LA CLASE A USAR Y EL MENSAJE CAMBIA DEPENDIENDO DEL ESTATUS RECIBIDO
    if (this.infoArticulo.ESTATUS == "A") {
      this.mensajeAccion = " por finalizada";
      this.clase = "red--text text--darken-3";
    } else {
      this.mensajeAccion = "alta";
      this.clase = "green--text text--darken-3";
    }
  },
}
</script>

<style>

</style>